module.exports = __webpack_public_path__ + "static/media/promo9.5c1d73ba.jpg";